"use strict";

(function () {
  'use strict';

  function profileWidgetCtrl() {
    var vm = this;

    this.$onInit = function () {// console.log(this);
    };
  }

  profileWidgetCtrl.$inject = [];
  angular.module('profile-widget', []).component('profileWidget', {
    bindings: {
      user: '<',
      logout: '&'
    },
    controller: profileWidgetCtrl,
    templateUrl: 'components/profile-widget/profile-widget.html'
  });
})();